export default __webpack_public_path__ + "static/media/07.b5099a64.jpg";